import { useState, useEffect, useRef } from 'react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import AddIcon from "@mui/icons-material/Add";
import { FilterContainer } from '../../pages/subjects/Subject.style';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import { styled } from 'styled-components';

const FilterHeadDropdown = styled.div`
margin-right: 10px;
display: flex;
align-items: center;
font-family: Roboto;
font-size: 14px;
font-style: normal;
font-weight: 600;
line-height: 20px;
letter-spacing: 0.28px;
color: var(--text-secondary, #808080);
position: relative;
max-width: 200px;
z-index: 10000;

`
const FilterContarinerDropdown = styled.div`
  display: flex;
  flex-direction: column;

  position: absolute;
  overflow: hidden;
  top: 40px;
  right: 0px;

  align-items: center;
  min-width: 100px;

  border-radius: 4px;
  background-color: #fbfbfb;
  box-shadow: 2px 2px 5px 1px #0008;

  p {
    cursor: pointer;
    padding: 5px;
    margin: 0px;
    :hover {
      background-color: gray;
    }
  }
`

export default function MyDropdown(props: any) {
    const { title, items, value, onChange } = props || {};
    const [isUnitOpen, setIsUnitOpen] = useState<any>(false)

    const unitRef = useRef(null)

    const handleSelect = (value: any) => {
        setIsUnitOpen(false)
        onChange(value)
    }
    const handleOpen = () => {
        setIsUnitOpen((prev: any) => !prev)
    }

    let isEditor = (global as any)?.isEditor;

    // <MyDropdown title={'Recommendation type'} items={[{name: 'A'}, {name: 'B'}, {name: 'C'}, {name: 'D'}]} value={recommendation.sortingType} onChange={(item:any) => {
    //     recommendation.sortingType = item;
    //     handleUpdateSubjects(recommendation)
    // }}></MyDropdown>
    let items0 = ((items || [])[0]) || {};
    return (
        <FilterHeadDropdown >
            <p>{title}:
                {isEditor && <span style={{
                    padding: '5px',
                    marginTop: '-10px',
                    display: 'inline-block'
                }}>{(value || items0).name}</span>}
                {!isEditor && <span className={'textDisabled'}>{(value || items0).name}</span>}

            </p>
            {Boolean(items?.length) && isEditor && <div ref={unitRef} onClick={() => handleOpen()}
                              style={{textAlign: 'left', zIndex: '1000', display: 'inline-block' }}>
                {isUnitOpen && (
                    <FilterContarinerDropdown>
                        {(items || []).map((item: any, index: number) => (
                            <p
                                className={'unitOpen'}
                                key={index}
                                onClick={(e) => {
                                    e.stopPropagation()
                                    handleSelect(item)
                                }}
                            >
                                {item.name}
                            </p>
                        ))}
                    </FilterContarinerDropdown>
                )}
                <KeyboardArrowDownIcon />
            </div>}
        </FilterHeadDropdown>
    )
}